const errorReducer = (reducer, actionName) => (state, action) => {
  const {type} = action;
  const matches = new RegExp(actionName+"\\.(REQUEST|SUCCESS|FAILURE)").exec(type);

  if (!matches) {
    return reducer(state, action);
  }

  const code = (action.error) ? action.error.code : undefined;
  const content = (action.error) ? action.error.content : undefined;
  return reducer({...state, error:{content, code}}, action);
}


export default errorReducer
